export default __webpack_public_path__ + "static/media/icon-cicle-success.9b813f06.svg";